import { useCallback } from 'react';
import type { To } from 'react-router';
import { useNavigate } from 'react-router';
import loginRequiredImage from '@/assets/images/profile_3d.png';
import { useBoundStore } from '@/shared/store';

type LoginRequiredModalOptions = {
	redirectTo?: To;
	replace?: boolean;
	state?: unknown;
};

const useLoginRequiredModal = () => {
	const navigate = useNavigate();
	const openModal = useBoundStore((state) => state.openModal);
	const closeModal = useBoundStore((state) => state.closeModal);

	const openLoginRequiredModal = useCallback(
		({
			redirectTo = '/onboarding',
			replace = false,
			state,
		}: LoginRequiredModalOptions = {}) => {
			openModal({
				title: '로그인이 필요해요',
				visual: (
					<img
						src={loginRequiredImage}
						alt="로그인"
						className="mx-auto w-32 object-contain"
					/>
				),
				children: (
					<p className="whitespace-pre-line text-center leading-7">
						{
							'소셜 로그인으로 간편하게 시작하고\n만땅의 기능을 더 편하게 이용해보세요'
						}
					</p>
				),
				primaryAction: {
					label: '로그인하기',
					onClick: () => {
						closeModal();
						navigate(redirectTo, { replace, state });
					},
				},
				secondaryAction: {
					label: '닫기',
					onClick: closeModal,
				},
			});
		},
		[closeModal, navigate, openModal],
	);

	return openLoginRequiredModal;
};

export default useLoginRequiredModal;
